interface Account {
  accountName?: string;
  accountNickName?: string;
  accountNumber?: string;
}

const formatAccount = ({ accountName, accountNickName, accountNumber }: Account) =>
  `${accountNickName || accountName}${accountNumber ? ` - ${accountNumber}` : ''}`;

export default formatAccount;
